module.exports = __webpack_public_path__ + "img/br.461ea031.svg";